<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 13 14">
    <path d="M11 7.75v3.75q0 0.203-0.148 0.352t-0.352 0.148h-3v-3h-2v3h-3q-0.203 0-0.352-0.148t-0.148-0.352v-3.75q0-0.008 0.004-0.023t0.004-0.023l4.492-3.703 4.492 3.703q0.008 0.016 0.008 0.047zM12.742 7.211l-0.484 0.578q-0.062 0.070-0.164 0.086h-0.023q-0.102 0-0.164-0.055l-5.406-4.508-5.406 4.508q-0.094 0.062-0.187 0.055-0.102-0.016-0.164-0.086l-0.484-0.578q-0.062-0.078-0.055-0.184t0.086-0.168l5.617-4.68q0.25-0.203 0.594-0.203t0.594 0.203l1.906 1.594v-1.523q0-0.109 0.070-0.18t0.18-0.070h1.5q0.109 0 0.18 0.070t0.070 0.18v3.188l1.711 1.422q0.078 0.062 0.086 0.168t-0.055 0.184z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-home.html